import React, { useEffect, useState } from 'react';
import InputField from 'Components/Input/InputField';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import ComboBox from 'Components/ComboBox/ComboBox';

function FilterOrder({
    isActiveFilter,
    onUpdatesIsActiveFilter,
    clientIdFilter,
    setClientIdFilter
}) {
    const [clientList, setClientList] = useState(null);

    function isActiveFilterSetter() {
        return onUpdatesIsActiveFilter(isActiveFilter === 'S' ? 'N' : 'S')
    }

    async function callToSetClientList() {
        const clientIds = await ExecuteAxios.api('get', `/client/lookup/`);
        setClientList(clientIds);
    }

    useEffect(() => {
        const onReady = async () => {
            await callToSetClientList();
        };

        onReady();
    }, [])

    const clientOptions = OptionsDataByAttributePath(clientList, ['description'], null, true);

    const filterUsersPanel = {
        width: '100%',
        height: '17%',
        display: 'flex',
        flexDirection: 'column'
    };

    return (
        <>
            <Panel style={filterUsersPanel}
                titlePage={'Filtros'}
                canViewCRUD={true}
            >
                <Panel style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '30px' }}>
                        <span className='span-sector-filter'>Ativo</span>
                        <InputField
                            setAttribute={(event) => isActiveFilterSetter(event)}
                            value={isActiveFilter}
                            checked={isActiveFilter === 'S'}
                            readOnly={false}
                            disabled={false}
                            type="checkbox"
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '30px' }}>
                        <span className='span-sector-filter'>Clientes</span>
                        <ComboBox
                            setAttribute={setClientIdFilter}
                            optionsData={clientOptions}
                            value={clientIdFilter}
                            dropdown={true}
                            style={{ minWidth: '300px', maxWidth: '300px' }}
                        />
                    </div>
                </Panel>
            </Panel>
        </>
    );
};

export default FilterOrder;